import axios from 'axios';
import _ from 'lodash';
import {
  INSTANCE_URL,
  APP_API_KEY,
  DEVELOPMENT_TYPE,
  detectBrowser,
  INSTANCE_URL_API4,
  SITE_URL
} from '../components/Common/constant';
import {
  deleteRequest,
  getRequest,
  postRequest,
  patchRequest
} from '../components/Common/network-call';
import { getHeaders } from '../components/Common/util-network';
import {
  fetchMyCourses,
  clearMyCourses
} from '../components/course-overview/actions';
import {
  fetchMyLiveSessions,
  clearMyLiveSessions
} from '../components/livesessions/actions';
import { updateSpeakersFiles } from '../components/myprofile/actions';
import {
  fetchAllSpeakers_Overview,
  fetchAllSponsors_Overview,
  fetchAllExhibitors_Overview
} from '../components/event-overview/actions';
import { fetchExhibitorAnalytics } from '../components/exhibitors/actions';
import { globalSearchLatest } from '../components/global-search/actions';

export const SHOW_SIDEBAR = 'SHOW_SIDEBAR';
export const LOGIN_MODAL = 'LOGIN_MODAL';
export const SIGNUP_MODAL = 'SIGNUP_MODAL';
export const ACTION_LOGIN = 'ACTION_LOGIN';
export const ACTION_LOGOUT = 'ACTION_LOGOUT';
export const RESET = 'RESET';
export const SESSION_TOKEN = 'SESSION_TOKEN';
export const USER_INFO = 'USER_INFO';
export const USER_DETAILS = 'USER_DETAILS';
export const USER_ACCESS = 'USER_ACCESS';
export const EVENT = 'EVENT';
export const EVENT_DETAILS = 'EVENT_DETAILS';
export const EVENT_FORMS_DETAILS = 'EVENT_FORMS_DETAILS';
export const EVENT_TAB_LIST = 'EVENT_TAB_LIST';
export const EVENT_ALL_TICKETS = 'EVENT_ALL_TICKETS';
export const DEVICE_SIZE = 'DEVICE_SIZE';
export const UPDATE_ACTIVE_TAB = 'UPDATE_ACTIVE_TAB';
export const EVENT_STRIPE_DETAILS = 'EVENT_STRIPE_DETAILS';
export const USER_DETAILS_QR = 'USER_DETAILS_QR';
export const APPUSER_CATEGORIES_LIST = 'APPUSER_CATEGORIES_LIST';
export const INTEREST_LIST = 'INTEREST_LIST';
export const EVENT_WEBVIEW_DETAILS = 'EVENT_WEBVIEW_DETAILS';
export const EVENT_ADVT_DETAILS = 'EVENT_ADVT_DETAILS';
export const REDIRECTING_CALLED_FROM = 'REDIRECTING_CALLED_FROM';
export const APPLY_COMMON_LOADER = 'APPLY_COMMON_LOADER';
export const INVOKE_NETWORK_MODAL = 'INVOKE_NETWORK_MODAL';
export const TIMEZONE_DETAILS = 'TIMEZONE_DETAILS';
export const TICKETS_FOR_EVENT = 'TICKETS_FOR_EVENT';
export const MEETING_POPUP_DETAILS = 'MEETING_POPUP_DETAILS';
export const FETCH_UNREAD_CHAT = 'FETCH_UNREAD_CHAT';
export const UNAUTHORISED_API_CALLED = 'UNAUTHORISED_API_CALLED';
export const SITE_CONTROL = 'SITE_CONTROL';

const eventTableFields =
  'eventid,eventname,eventicon,eventcover,eventdescription,country,eventstartdate,eventenddate,eventtimezone,seocode,eventcode,themecolor,clientidfk,group_number,chatinvites,isautopublish_qa,showconvertedtimezone,createdon,iosappstorelink,androidplaystorelink';
const languageFields = 'id,languagekey,languagetext,languagejson,isenabled';
const cliendTableFields = 'validityfrom,validupto';
const eventTableRelatedTables = `eventsettings_by_eventid,eventlanguages_by_eventid,clients_by_clientidfk,locationmaps_by_eventid&eventlanguages_by_eventid.fields=${languageFields}&clients_by_clientidfk.fields=${cliendTableFields}`;
const eventTableFieldsAndRelated = `fields=${eventTableFields}&related=${eventTableRelatedTables}`;

export const checkEvent = (session, seocode, callback) => {
  // seocode = 'mycustomdomain';

  let filter = encodeURI(`(seocode=${seocode})`),
    url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=(${filter})&${eventTableFieldsAndRelated}`,
    urlAPi4 = `${INSTANCE_URL_API4}/api/v2/eventify/_table/event?fields=eventid&filter=(${filter})`;

  return dispatch => {
    if (
      session.seocode &&
      session.seocode != '' &&
      session.seocode.toLowerCase() != seocode.toLowerCase()
    ) {
      dispatch({
        type: EVENT,
        payload: {}
      });
      dispatch(logout(session));
    }
    getRequest(
      url,
      session,
      dispatch,
      data => {
        if (data.resource && data.resource.length > 0) {
          // ----- event and event-details set
          dispatch({
            type: EVENT,
            payload: data.resource[0]
          });
          dispatch({
            type: EVENT_DETAILS,
            payload: { resource: data.resource[0] }
          });

          // ----- event theme color set to root
          // let root = document.querySelector(':root');
          let root = document.documentElement;
          root.style.setProperty('--theme-color', data.resource[0].themecolor);

          // ----- creating the timezone details
          // - if conversion required in app
          let tzObj = {};
          if (data.resource[0].showconvertedtimezone)
            tzObj.showconvertedtimezone =
              data.resource[0].showconvertedtimezone;
          // - date and str conv.
          let date = new Date();
          let dateAsString = date.toString();
          tzObj.today = date;
          tzObj.dateAsString = dateAsString;
          // - tz selection
          const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
          let timezone = null;
          if (data.resource[0] && data.resource[0].eventtimezone)
            timezone = data.resource[0].eventtimezone;
          if (!timezone) {
            data.resource[0] = {
              ...data.resource[0],
              eventtimezone: tz
            };
            timezone = tz;
          }
          tzObj.eventTimezone = timezone;
          tzObj.clientTimezone = tz;
          // - timezone set
          dispatch({ type: TIMEZONE_DETAILS, payload: tzObj });

          // ----- callback sent
          callback({ success: 1, resource: data.resource });
        } else {
          getRequest(
            urlAPi4,
            session,
            dispatch,
            api4Res => {
              if (!_.isEmpty(api4Res?.resource)) {
                // window.location.assign(`https://${seocode}.${SITE_URL}/p`);
                window.location.assign(`https://${window.location.hostname}/p`);
              } else {
                callback({ success: 0 });
              }
            },
            api4Error => {
              callback({ success: 0 });
            }
          );
        }
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const checkToken = (token, appuserid, eventid, callback) => {
  let config = {
    headers: {
      contentType: 'application/json; charset=utf-8',
      'X-DreamFactory-Api-Key': APP_API_KEY,
      'X-DreamFactory-Session-Token': token
    }
  };
  let url = `${INSTANCE_URL}/api/v2/user/session?appuserid=${appuserid}&eventid=${eventid}&callfrom=appwebprofile`;
  let response = axios.get(url, config);

  return dispatch => {
    response
      .then(({ data }) => {
        if (data.is_valid_user) {
          dispatch({
            type: SESSION_TOKEN,
            payload: {
              session_token: data.session_token,
              id: data.id
            }
          });
          dispatch({
            type: USER_INFO,
            payload: {
              appuserid: appuserid,
              email: data.email
            }
          });
          dispatch(
            fetchMyProfile(
              {
                apiKey: APP_API_KEY,
                sessionToken: data.session_token,
                eventid: eventid,
                udfid: data.id,
                userid: appuserid
              },
              res => {}
            )
          );
          callback({ success: 1 });
        } else {
          dispatch(resetAll());
          callback({ success: 0 });
        }
      })
      .catch(error => {
        callback({ success: 0, message: error });
      });
  };
};

export const deviceSize = obj => {
  return dispatch => {
    dispatch({ type: DEVICE_SIZE, payload: obj });
  };
};

export const showSidebar = value => {
  return dispatch => {
    dispatch({ type: SHOW_SIDEBAR, payload: value });
  };
};

export const loginModal = obj => {
  return dispatch => {
    dispatch({ type: LOGIN_MODAL, payload: obj });
  };
};

export const signupModal = obj => {
  return dispatch => {
    dispatch({ type: SIGNUP_MODAL, payload: obj });
  };
};

export const mainLogin = (session, values, alsoPurchase = '', callback) => {
  let config = {
    headers: {
      contentType: 'application/json; charset=utf-8',
      'X-DreamFactory-Api-Key': APP_API_KEY
    }
  };

  if (DEVELOPMENT_TYPE === 'koachify') {
    values = { ...values, remember_me: true };
    // Note: Set remember_me=true to get a JWT (token) that can be refreshed forever (until logout) without authentication.

    let url = `${INSTANCE_URL}/api/v2/user/session`;
    let response = axios.post(url, values, config);

    return dispatch => {
      // Maintaining unauthorised api call flag here
      dispatch({ type: UNAUTHORISED_API_CALLED, payload: false });

      response
        .then(({ data }) => {
          // console.log('session data:- ', data);
          // Validate user
          dispatch(
            validateUserRelatedToEvent(
              data.id,
              data,
              { ...session, sessionToken: data.session_token },
              alsoPurchase,
              callback
            )
          );
        })
        .catch(error => {
          callback({ success: 0, message: error });
        });
    };
  } else {
    let filter = encodeURI(`eventid=${session.eventid}`);
    let urlevent = `${INSTANCE_URL}/api/v2/eventify/_table/event?fields=eventid,eventname,seocode,eventcode&related=eventsettings_by_eventid&filter=(${filter})`;

    return dispatch => {
      // Maintaining unauthorised api call flag here
      dispatch({ type: UNAUTHORISED_API_CALLED, payload: false });

      getRequest(
        urlevent,
        session,
        dispatch,
        respo => {
          if (respo.resource && respo.resource.length > 0) {
            let eventcode = respo.resource[0].eventcode;
            let eventsetting = respo.resource[0].eventsettings_by_eventid[0];
            let filter1 = encodeURI(
              `(emailid=${values.email})AND(handshakecode=${values.password})AND(eventcode=${eventcode})AND(eventid=${session.eventid})`
            );
            let urlpass = `${INSTANCE_URL}/api/v2/eventify/_table/magiclinkstatus?filter=(${filter1})`;

            // ===== This flow is updated for possible security issues, and login API for webportal is updated by Anubhab Mukherjee on 12/08/2023
            let body = {
              email: values.email,
              eventid: session.eventid,
              callfrom: 'webportal',
              password: values.password
            };
            let url = `${INSTANCE_URL}/api/v2/eventifyscript/login`;

            let response = axios.post(url, body, config);
            response
              .then(({ data }) => {
                // console.log('data :- ', data);
                if (data.result) {
                  data = data.result;

                  dispatch(
                    validateUserRelatedToEvent(
                      data.id,
                      data,
                      {
                        ...session,
                        sessionToken: data.session_token
                      },
                      alsoPurchase,
                      callback
                    )
                  );
                } else if (data.is_error == 1) {
                  callback({
                    success: 3,
                    type: 'waitlist',
                    message: data.message
                  });
                } else if (data.is_error == 2) {
                  callback({
                    success: 3,
                    type: 'not-registered',
                    message: data.message
                  });
                } else if (data.is_error == 3) {
                  callback({
                    success: 3,
                    type: 'user-deactivated',
                    message: data.message
                  });
                } else {
                  callback({ success: 0 });
                }
              })
              .catch(error => {
                callback({ success: 0 });
              });

            // ===== This flow is updated for possible security issues, and login API for webportal is updated by Anubhab Mukherjee on 12/08/2023
            // getRequest(
            //   urlpass,
            //   session,
            //   dispatch,
            //   data1 => {
            //     // console.log('data1 :- ', data1);
            //     let body = {
            //       email: values.email,
            //       eventid: session.eventid,
            //       callfrom: 'webportal',
            //     };
            //     let url = `${INSTANCE_URL}/api/v2/eventifyscript/login`;

            //     if (data1.resource && data1.resource.length > 0) {
            //       // console.log('passcode login');
            //       // Login with default token
            //       let response = axios.post(url, body, config);
            //       response
            //         .then(({ data }) => {
            //           // console.log('data :- ', data);
            //           if (data.result) {
            //             data = data.result;

            //             dispatch(
            //               validateUserRelatedToEvent(
            //                 data.id,
            //                 data,
            //                 {
            //                   ...session,
            //                   sessionToken: data.session_token
            //                 },
            //                 alsoPurchase,
            //                 callback
            //               )
            //             );
            //           } else if (data.is_error == 1) {
            //             callback({
            //               success: 3,
            //               type: 'waitlist',
            //               message: data.message
            //             });
            //           } else if (data.is_error == 2) {
            //             callback({
            //               success: 3,
            //               type: 'not-registered',
            //               message: data.message
            //             });
            //           } else if (data.is_error == 3) {
            //             callback({
            //               success: 3,
            //               type: 'user-deactivated',
            //               message: data.message
            //             });
            //           } else {
            //             callback({ success: 0 });
            //           }
            //         })
            //         .catch(error => {
            //           callback({ success: 0 });
            //         });
            //     } else {
            //       if (eventsetting.eventcodelogin) {
            //         if (eventcode == values.password) {
            //           // console.log('eventcode login');
            //           // Login with default token
            //           let response = axios.post(url, body, config);
            //           response
            //             .then(({ data }) => {
            //               // console.log('data :- ', data);
            //               if (data.result) {
            //                 data = data.result;

            //                 dispatch(
            //                   validateUserRelatedToEvent(
            //                     data.id,
            //                     data,
            //                     {
            //                       ...session,
            //                       sessionToken: data.session_token
            //                     },
            //                     alsoPurchase,
            //                     callback
            //                   )
            //                 );
            //               } else if (data.is_error == 1) {
            //                 callback({
            //                   success: 3,
            //                   type: 'waitlist',
            //                   message: data.message
            //                 });
            //               } else if (data.is_error == 2) {
            //                 callback({
            //                   success: 3,
            //                   type: 'not-registered',
            //                   message: data.message
            //                 });
            //               } else if (data.is_error == 3) {
            //                 callback({
            //                   success: 3,
            //                   type: 'user-deactivated',
            //                   message: data.message
            //                 });
            //               } else if (data.is_error == 4) {
            //                 callback({
            //                   success: 3,
            //                   type: 'attendee-site-restriction',
            //                   message: data.message
            //                 });
            //               } else {
            //                 callback({
            //                   success: 0
            //                 });
            //               }
            //             })
            //             .catch(error => {
            //               callback({ success: 0 });
            //             });
            //         } else {
            //           callback({ success: 0 });
            //         }
            //       } else {
            //         callback({ success: 0 });
            //       }
            //     }
            //   },
            //   error => {}
            // );
          } else {
            callback({ success: 0 });
          }
        },
        error => {
          callback({
            sucess: 0,
            message: error,
            type: 'token-error'
          });
        }
      );
    };
  }
};

// ----- action for 401 403 toekn expire error
export const recallCheckEvent = (session, callback) => {
  // ----- storing a local version of session before clearinmg localStorage
  const localSession = {
    apiKey: session.apiKey,
    eventid: session.eventid,
    eventname: session.eventname,
    eventtimezone: session.eventtimezone,
    seocode: session.seocode
  };

  // ----- clearing localStorage
  try {
    localStorage.setItem(
      'webportal',
      JSON.stringify({ isLoggedIn: false, session: localSession })
    );
  } catch (err) {}

  return dispatch => {
    // Maintaining a flag here
    dispatch({ type: UNAUTHORISED_API_CALLED, payload: true });
    dispatch(
      checkEvent(localSession, session.seocode, res => {
        callback(res);
      })
    );
  };
};

const validateUserRelatedToEvent = (
  userid,
  logindata,
  session,
  alsoPurchase,
  callback
) => {
  // Check whether logged in user is admin or not
  let filter = encodeURI(`(eventid=${session.eventid})AND(dfid=${userid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=tickets_by_ticketid,ticket_attendees_by_userid&filter=(${filter})`;
  let response = axios.get(url, getHeaders(session));

  return dispatch => {
    response
      .then(({ data }) => {
        // console.log('user info :- ', data);
        if (data.resource.length > 0) {
          if (DEVELOPMENT_TYPE === 'eventify') {
            // Not required in overview page, if in future required open this comment
            // dispatch(
            //   fetchUserQR({ ...session, userid: data.resource[0].appuserid })
            // );
          }

          dispatch(
            fetchContentTabs({
              ...session
            })
          );

          if (alsoPurchase != '') {
            if (alsoPurchase === 'course') {
              // console.log('course purchase login.....');
              dispatch(
                fetchMyCourses(
                  {
                    ...session,
                    userid: data.resource[0].appuserid
                  },
                  resmycourse => {
                    // console.log('resmycourse :- ', resmycourse);

                    dispatch({
                      type: ACTION_LOGIN,
                      payload: true
                    });
                    dispatch({
                      type: SESSION_TOKEN,
                      payload: logindata
                    });
                    dispatch({
                      type: USER_INFO,
                      payload: data.resource[0]
                    });
                    dispatch({
                      type: USER_DETAILS,
                      payload: data.resource[0]
                    });

                    callback({
                      success: 1,
                      data: {
                        user: data.resource[0],
                        mycourse: resmycourse.data,
                        mysession: []
                      }
                    });
                  }
                )
              );

              dispatch(
                fetchMyLiveSessions({
                  ...session,
                  userid: data.resource[0].appuserid
                })
              );
              dispatch(
                fetchEventForms({
                  ...session,
                  eventid: data.resource[0].eventid
                })
              );
            } else {
              // console.log('session purchase login.....');
              dispatch(
                fetchMyLiveSessions(
                  {
                    ...session,
                    userid: data.resource[0].appuserid
                  },
                  resmysession => {
                    // console.log('resmysession :- ', resmysession);

                    dispatch({
                      type: ACTION_LOGIN,
                      payload: true
                    });
                    dispatch({
                      type: SESSION_TOKEN,
                      payload: logindata
                    });
                    dispatch({
                      type: USER_INFO,
                      payload: data.resource[0]
                    });
                    dispatch({
                      type: USER_DETAILS,
                      payload: data.resource[0]
                    });

                    callback({
                      success: 1,
                      data: {
                        user: data.resource[0],
                        mycourse: [],
                        mysession: resmysession.data
                      }
                    });
                  }
                )
              );
              dispatch(
                fetchMyCourses({
                  ...session,
                  userid: data.resource[0].appuserid
                })
              );
              dispatch(
                fetchEventForms({
                  ...session,
                  eventid: data.resource[0].eventid
                })
              );
            }
          } else {
            // console.log('only login.....');
            dispatch({ type: ACTION_LOGIN, payload: true });
            dispatch({ type: SESSION_TOKEN, payload: logindata });
            dispatch({
              type: USER_INFO,
              payload: data.resource[0]
            });
            dispatch({
              type: USER_DETAILS,
              payload: data.resource[0]
            });
            if (DEVELOPMENT_TYPE === 'koachify') {
              dispatch(
                fetchMyCourses({
                  ...session,
                  userid: data.resource[0].appuserid
                })
              );
              dispatch(
                fetchMyLiveSessions({
                  ...session,
                  userid: data.resource[0].appuserid
                })
              );
              // dispatch(
              //   fetchEventDetails({
              //     ...session,
              //     eventid: data.resource[0].eventid
              //   })
              // );
              dispatch(
                fetchEventForms({
                  ...session,
                  eventid: data.resource[0].eventid
                })
              );
            }
            callback({ success: 1, data: data.resource[0] });
          }
        } else {
          callback({ success: 2, message: 'Invalid User!' });
        }
      })
      .catch(error => {
        // callback({ success: 0, message: error });
      });
  };
};

export const validateEmailForAppUser = (session, values, callback) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(email=${values.email})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        if (data.resource.length > 0) {
          callback({ success: 2 });
        } else {
          callback({ success: 1 });
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchUserQR = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/userqr?service=getqr`;
  let body = {
    userid: session.userid,
    source: 'inherit',
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({ type: USER_DETAILS_QR, payload: response });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const fetchUserAccess = (session, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventifyscript_support`;
  let body = {
    eventid: session.eventid,
    appuserid: session.userid,
    type: 'appuserAccess'
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        dispatch({ type: USER_ACCESS, payload: response });
        callback({ success: 1, response: response });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const signUp = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/koachifyscript/signupAppuser`;
  let body = {
    ...values,
    username: `${values.firstname} ${values.lastname}`,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        if (response.success == 1) {
          dispatch(
            mainLogin(
              session,
              {
                email: values.email,
                password: values.password
              },
              '',
              callback
            )
          );
        }
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const signupAppuserEmail = (session, email, callback) => {
  let url = `${INSTANCE_URL}/api/v2/koachifyscript/signupAppuserEmail`;
  let body = {
    email: email,
    eventid: session.eventid
  };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        // console.log('response :- ', response);
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0 });
      }
    );
  };
};

export const logout = (session, callback = null) => {
  let url = `${INSTANCE_URL}/api/v2/user/session`;
  let response = axios.delete(url, getHeaders(session));

  return dispatch => {
    dispatch(clearMyCourses());
    dispatch(clearMyLiveSessions());

    response
      .then(({ data }) => {
        dispatch({ type: ACTION_LOGOUT, payload: false });
        dispatch(globalSearchLatest([]));
        callback({ success: 1 });
      })
      .catch(error => {
        // nothing to do
        dispatch({ type: ACTION_LOGOUT, payload: false });
        callback({ success: 0 });
      });
  };
};

export const resetAll = () => {
  return dispatch => {
    dispatch({ type: 'RESET' });
  };
};

// Common Functions
export const fetchEventDetails = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/event?filter=(${filter})&${eventTableFieldsAndRelated}`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // dispatch({
        //   type: EVENT,
        //   payload: data.resource[0]
        // });
        dispatch({
          type: EVENT_DETAILS,
          payload: { resource: data.resource[0] }
        });

        if (DEVELOPMENT_TYPE === 'eventify') {
          let speakerSortBy =
            data.resource[0].eventsettings_by_eventid[0].speakersort;
          let sponsorSortBy =
            data.resource[0].eventsettings_by_eventid[0].sponsorsort;
          let exhibitorSortBy =
            data.resource[0].eventsettings_by_eventid[0].exhibitorsort;
          dispatch(
            fetchAllSpeakers_Overview(session, speakerSortBy, res => {})
          );
          dispatch(
            fetchAllSponsors_Overview(session, sponsorSortBy, res => {})
          );
          dispatch(
            fetchAllExhibitors_Overview(session, exhibitorSortBy, res => {})
          );
        }

        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchEventForms = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/eventsettings?fields=id,eventformid,sesseionratingformid,sponsorformid,exhibitorformid,gamification_title,gamification_desc&related=event_forms_by_eventformid,event_forms_by_exhibitorformid,event_forms_by_sesseionratingformid,event_forms_by_sponsorformid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_FORMS_DETAILS,
          payload: { resource: data.resource[0] }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchMyProfile = (session, callback) => {
  if (_.isEmpty(session.sessionToken)) return dispatch => {};

  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})`
  );
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser?related=tickets_by_ticketid,ticket_attendees_by_userid,speaker_by_speakeridfk,sponsor_by_sponsoridfk,exhibitors_by_exhibitoridfk&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // console.log('fetch profile info: ', data);
        if (data.resource.length == 0) {
          // ----- storing a local version of session before clearinmg localStorage
          let localSession = {
            apiKey: session.apiKey,
            eventid: session.eventid,
            eventname: session.eventname,
            eventtimezone: session.eventtimezone,
            seocode: session.seocode
          };

          // ----- clearing localStorage
          try {
            localStorage.clear();
          } catch (err) {}

          // ----- recalling the 1st api ever called
          dispatch(
            recallCheckEvent(localSession, res => {
              successCallback(res);
            })
          );
        } else {
          callback({ success: true });
          dispatch({
            type: USER_DETAILS,
            payload: {}
          });
          setTimeout(() => {
            dispatch({
              type: USER_DETAILS,
              payload: data.resource[0]
            });
          }, 100);
          dispatch(
            speakerAttachment(data.resource[0].speaker_by_speakeridfk, dispatch)
          );
        }
      },
      error => {}
    );
  };
};

export const fetchContentTabs = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/apptabs?fields=apptabid,displaytabname,tabslected,isenabled,taborder&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_TAB_LIST,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchTickets = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?related=event_forms_by_formid&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_ALL_TICKETS,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const speakerAttachment = (speaker, dispatch) => {
  if (!_.isEmpty(speaker)) {
    let fileName1 = '';
    let fileName2 = '';
    let fileName3 = '';
    let fileName4 = '';
    let fileName5 = '';
    if (speaker.file1) {
      let f1 = speaker.file1.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName1 = f2 + '.' + ext;
    }
    if (speaker.file2) {
      let f1 = speaker.file2.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName2 = f2 + '.' + ext;
    }
    if (speaker.file3) {
      let f1 = speaker.file3.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName3 = f2 + '.' + ext;
    }
    if (speaker.file4) {
      let f1 = speaker.file4.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName4 = f2 + '.' + ext;
    }
    if (speaker.file5) {
      let f1 = speaker.file5.split('/').pop();
      let f2 = f1.substr(0, f1.lastIndexOf('_'));
      let ext = f1.split('.').pop();

      fileName5 = f2 + '.' + ext;
    }
    let files = [
      {
        position: 'file1',
        file: speaker.file1 ? speaker.file1 : '',
        filename: fileName1
      },
      {
        position: 'file2',
        file: speaker.file2 ? speaker.file2 : '',
        filename: fileName2
      },
      {
        position: 'file3',
        file: speaker.file3 ? speaker.file3 : '',
        filename: fileName3
      },
      {
        position: 'file4',
        file: speaker.file4 ? speaker.file4 : '',
        filename: fileName4
      },
      {
        position: 'file5',
        file: speaker.file5 ? speaker.file5 : '',
        filename: fileName5
      }
    ];
    dispatch(updateSpeakersFiles(files));
  }
};

export const updateActiveTab = name => {
  return dispatch => {
    dispatch({ type: UPDATE_ACTIVE_TAB, payload: name });
  };
};

export const fetchTicketStripe = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/ticket_stripe?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_STRIPE_DETAILS,
          payload: { resource: data.resource[0] }
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchAndFilterByBookMark = (
  url,
  session,
  type,
  dispatch,
  callback
) => {
  let filter = encodeURI(
    `(eventid=${session.eventid})AND(appuserid=${session.userid})AND(type=${type})`
  );
  let bookmarkUrl = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?fields=bookmarkid,typeid&filter=(${filter})`;
  getRequest(
    url,
    session,
    dispatch,
    data => {
      getRequest(bookmarkUrl, session, dispatch, bookmarkData => {
        for (let arr in data.resource) {
          let match = [];
          if (type === 'exhibitor') {
            match = _.filter(bookmarkData.resource, obj => {
              return obj.typeid === data.resource[arr].exhibitorid;
            });
          } else if (type === 'sponsor') {
            match = _.filter(bookmarkData.resource, obj => {
              return obj.typeid === data.resource[arr].sponsorid;
            });
          }

          data.resource[arr] = {
            ...data.resource[arr],
            isBookMarked: false
          };
          if (match.length > 0) {
            data.resource[arr] = {
              ...data.resource[arr],
              isBookMarked: true
            };
          }
        }

        if (type === 'sponsor') {
          // listing sponsors membership priority wise
          let arr = _.sortBy(data.resource, spon => {
            return spon.membershiptype_by_categoryid?.priorityindex;
          });

          data.resource = arr;
        }

        callback(data);
      });
    },
    error => {
      callback({ message: error });
    }
  );
};

export const saveBookmark = (session, type, typeid, callback) => {
  const url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks`;
  const body = {
    resource: [
      {
        eventid: `${session.eventid}`,
        type,
        typeid: `${typeid}`,
        appuserid: `${session.userid}`
      }
    ]
  };
  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        if (type === 'exhibitor') {
          dispatch(
            fetchExhibitorAnalytics(session, typeid, res => {
              if (res.success && res.message == 'Success') {
                callback({
                  success: 1,
                  data: response.resource
                });
              }
            })
          );
        } else {
          callback({ success: 1, data: response.resource });
        }
      },
      error => {
        callback(error);
      }
    );
  };
};

export const deleteBookmark = (session, type, typeid, callback) => {
  const filter = encodeURI(
    '(typeid=' +
      typeid +
      ')AND(appuserid=' +
      session.userid +
      ')AND(type=' +
      type.toLowerCase() +
      ')AND(eventid=' +
      session.eventid +
      ')'
  );
  const url = `${INSTANCE_URL}/api/v2/eventify/_table/bookmarks?filter=(${filter})`;
  return dispatch => {
    deleteRequest(
      url,
      session,
      dispatch,
      response => {
        callback({ success: 1, response });
      },
      error => {
        callback(error);
      }
    );
  };
};

export const fetchAppuserCategory = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser_groups?&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: APPUSER_CATEGORIES_LIST,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const fetchInterests = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/interests?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: INTEREST_LIST,
          payload: data.resource
        });
        callback({ success: 1 });
      },
      error => {}
    );
  };
};

export const postAnalytics = (
  session,
  screen,
  type,
  associatedid,
  searchtext = null,
  hassearchresult = 0,
  callback
) => {
  // Post Analytics Data
  let browserData = detectBrowser();
  let anaData = {};
  anaData.platform = 'web';
  anaData.devicename = browserData.browserName;
  anaData.model = browserData.browserName;
  anaData.systemversion = browserData.fullVersion;
  anaData.device = '';
  anaData.version = browserData.fullVersion;
  anaData.build = '';
  anaData.eventid = session.eventid;

  let anaDataObjStr = JSON.stringify(anaData);

  let values = {
    eventid: session.eventid,
    screen,
    type,
    associatedid,
    searchtext,
    data: anaDataObjStr,
    hassearchresult
  };
  // values.eventid = session.eventid;
  // values.screen = screen;
  // values.type = type;
  // values.associatedid = associatedid;
  // values.searchtext = searchtext;
  // values.data = JSON.stringify(anaData);
  // values.hassearchresult = hassearchresult;

  let url = `${INSTANCE_URL}/api/v2/eventify/_table/app_analytics`;
  let body = { resource: values };

  return dispatch => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      response => {
        callback({ success: 1 });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const updateAppuser = (session, userData, callback) => {
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/appuser`;
  let body = { resource: userData };

  return dispatch => {
    patchRequest(
      url,
      body,
      session,
      dispatch,
      res => {
        if (userData.appuserid == res.resource[0].appuserid) {
          dispatch(
            fetchMyProfile(session, res => {
              callback({ success: true });
            })
          );
        }
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const fetchWebviewDetails = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/webview?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        dispatch({
          type: EVENT_WEBVIEW_DETAILS,
          payload: data.resource[0]
        });
        callback({ success: 1, resource: data.resource[0] });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const fetchAdvertisements = (session, callback) => {
  let filter = encodeURI(`(eventid=${session.eventid})AND(isenabled=1)`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/advertisement?filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      data => {
        // 'overviewinline','sidemenu','splash','home'
        dispatch({ type: EVENT_ADVT_DETAILS, payload: data.resource });
        callback({ success: 1, resource: data.resource });
      },
      error => {
        callback({ success: 0, error });
      }
    );
  };
};

export const redirectingCalledFrom = calledFrom => {
  return dispatch => {
    dispatch({ type: REDIRECTING_CALLED_FROM, payload: calledFrom });
  };
};

export const forgotPasscode = (session, values, callback) => {
  let url = `${INSTANCE_URL}/api/v2/magicemail`;

  return dispatch => {
    postRequest(
      url,
      values,
      session,
      dispatch,
      res => {
        callback({ success: true, data: res });
      },
      error => {
        callback({ success: false, message: error });
      }
    );
  };
};

export const commonLoaderHandler = value => {
  return dispatch => {
    dispatch({ type: APPLY_COMMON_LOADER, payload: value });
  };
};

export const commonNetworkModal = value => {
  return dispatch => {
    dispatch({ type: INVOKE_NETWORK_MODAL, payload: value });
  };
};

export const fetchTicketsForEvent = (session, callback) => {
  let filter = encodeURI(`eventid=${session.eventid}`);
  let url = `${INSTANCE_URL}/api/v2/eventify/_table/tickets?fields=id,ticketname&filter=(${filter})`;

  return dispatch => {
    getRequest(
      url,
      session,
      dispatch,
      res => {
        dispatch({ type: TICKETS_FOR_EVENT, payload: res.resource });
        callback({ success: 1, data: res.resource });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

export const meetingPopupAction = value => {
  return dispatch => dispatch({ type: MEETING_POPUP_DETAILS, payload: value });
};

export const fetchUnreadChat = (session, callback) => {
  let fetchUrl = `${INSTANCE_URL}/api/v2/networkusers`,
    postBody = {
      appuserid: session.userid,
      eventid: session.eventid,
      section: 'onlyunreadcount'
    };

  return dispatch => {
    postRequest(
      fetchUrl,
      postBody,
      session,
      dispatch,
      response => {
        dispatch({
          type: FETCH_UNREAD_CHAT,
          payload: {
            data: response.users,
            totalUnread: response.totalUnread
          }
        });
      },
      error => {
        callback({ success: 0, message: error });
      }
    );
  };
};

// Manages how user access the site
// allow => can access site
// expired => 404, can not access site
// restrict => Show only minimum event details on overview, can not access site
// allow-admin => Allow admin on restrict mode
export const setSiteControl = value => {
  return dispatch => dispatch({ type: SITE_CONTROL, payload: value });
};
